import React from 'react';

import TooltipStep from '../TooltipStep';

interface TitvProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const Titv = (props: TitvProps) => (
  <TooltipStep
    {...props}
    title="The Information’s TITV"
    description="First in tech news and analysis from the people who break and shape the story. Watch every weekday at 10 am PT/1 pm ET."
  />
);

export default Titv;
